import { ControlButton, Controls as ReactFlowControls } from '@xyflow/react';
import { ListChevronsDownUp, ListChevronsUpDown } from 'lucide-react';
import styles from '@/components/flow/components/controls/controls.module.css';
import useFlowStore from '@/store/flow';
import { TCardSize } from '@/types/common.ts';
import { AppEvent } from '@/types/event-emitter.types.ts';
import { emitter } from '@/utils/event-emitter.ts';

const Controls = () => {
	const cardSize = useFlowStore((state) => state.cardSize);
	const setIsExtendedMode = useFlowStore((state) => state.setCardSize);
	const handleUpdateChartView = () => {
		emitter.emit(
			cardSize === TCardSize.COMPACT
				? AppEvent.EXPAND_ALL_CARDS
				: AppEvent.COLLAPSE_ALL_CARDS
		);
		setIsExtendedMode(
			cardSize === TCardSize.COMPACT ? TCardSize.EXTENDED : TCardSize.COMPACT
		);
	};

	return (
		<ReactFlowControls className={styles.controls}>
			<ControlButton onClick={handleUpdateChartView}>
				{cardSize === TCardSize.COMPACT ? (
					<ListChevronsDownUp />
				) : (
					<ListChevronsUpDown />
				)}
			</ControlButton>
		</ReactFlowControls>
	);
};

export default Controls;
